module.exports = require('./components/projectinfo');
